export enum ActivationTypes {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
}

export interface IActivation {
  activationStatus: ActivationTypes;
  activationReason?: string;
  activationDetails?: string;
  activationEffectiveDate?: Date;
}
